import { render } from "./PhotoUploader.vue?vue&type=template&id=6ab0326f&lang=pug"
import script from "./PhotoUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoUploader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__